import { FC } from 'react'
import { UserProtectedRoute } from 'routes'
import { OfferList } from 'components/Offer'

const OfferPage: FC = () => {
  return (
    <UserProtectedRoute>
      <OfferList />
    </UserProtectedRoute>
  )
}

export default OfferPage
